// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../resources/layout-and-structure/Box.res.js";
import * as Media from "../primitives/Media.res.js";
import * as React from "react";
import * as Navigation from "../primitives/Navigation.res.js";
import * as AsyncResult from "../primitives/AsyncResult.res.js";
import * as Breakpoints from "../resources/theme/Breakpoints.res.js";
import * as Placeholder from "../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "../primitives/ReactDomElement.res.js";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";
import * as Stylex from "@stylexjs/stylex";
import * as CanaryPageHeader from "../resources/layout-and-structure/CanaryPageHeader.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OperationDurations from "./OperationDurations.res.js";
import * as ListNavigationState from "./ListNavigationState.res.js";
import * as PredictiveLoadingBar from "../resources/feedback-indicators/PredictiveLoadingBar.res.js";
import * as UseResizeObserver from "react-aria/private/utils/useResizeObserver";
let make = React.memo(props => {
  let match = {
    className: "backgroundColor-x150bj9m borderLeftColor-x1qlbgvd borderLeftStyle-x19ypqd9 borderLeftWidth-xe0pwq display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf height-x5yr21d overflow-xysyzu8 position-x1n2onr6 zIndex-x1vjfegm",
    "data-style-src": "wino-gc:src/core/NextResourceDetailsPage.res.js:24"
  };
  let domRef = Stdlib_Option.map(props.rootRef, prim => prim);
  return JsxRuntime.jsx("div", {
    children: props.children,
    ref: domRef,
    className: match.className,
    style: match.style
  });
});
let styles$1 = {
  root: {
    "alignSelf-kSGwAc": "alignSelf-xqcrz7y",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-xou54vl",
    "minWidth-k7Eaqz": "minWidth-xeuugli",
    "width-kzqmXN": "width-xh8yej3",
    "zIndex-kY2c9j": "zIndex-x1vjfegm",
    $$css: "wino-gc:src/core/NextResourceDetailsPage.res.js:51"
  }
};
function NextResourceDetailsPage$Column(props) {
  let columnDomRef = React.useRef(null);
  let desktopScreenSize = Media.use(Breakpoints.large);
  let match = React.useState(() => true);
  let setFitsViewport = match[1];
  let updateFitsViewport = () => {
    let column = ReactDomElement.toOptionalDomElement(columnDomRef);
    if (column === undefined) {
      return;
    }
    let column$1 = Primitive_option.valFromOption(column);
    setFitsViewport(param => column$1.offsetHeight <= window.innerHeight - 80);
  };
  React.useLayoutEffect(() => {
    updateFitsViewport();
    let onResize = param => updateFitsViewport();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [desktopScreenSize]);
  UseResizeObserver.useResizeObserver({
    ref: columnDomRef,
    onResize: updateFitsViewport
  });
  let sticky = desktopScreenSize && match[0];
  let stickyTop = (CanaryPageHeader.contentOffset | 0).toString() + "px";
  let match$1 = Stylex.props(styles$1.root, sticky ? {
    position: "sticky",
    top: stickyTop
  } : {});
  return JsxRuntime.jsx("div", {
    children: props.children,
    ref: Primitive_option.some(columnDomRef),
    className: match$1.className,
    style: match$1.style
  });
}
function NextResourceDetailsPage$ResourceDetailsBody(props) {
  let stale = props.stale;
  let desktopScreenSize = Media.use(Breakpoints.large);
  let rootProps = stale ? {
    inert: "true"
  } : undefined;
  let match = {
    0: {
      className: "transition-x1myia39 display-xrvj5dj gap-x1c1vhfx gridTemplateColumns-x1mkdm3x transition-x9kvfbb",
      "data-style-src": "wino-gc:src/core/NextResourceDetailsPage.res.js:102; wino-gc:src/core/NextResourceDetailsPage.res.js:115"
    },
    2: {
      className: "transition-x1myia39 display-xrvj5dj gap-x1c1vhfx gridTemplateColumns-x10rj6eh transition-x9kvfbb",
      "data-style-src": "wino-gc:src/core/NextResourceDetailsPage.res.js:102; wino-gc:src/core/NextResourceDetailsPage.res.js:108; wino-gc:src/core/NextResourceDetailsPage.res.js:115"
    },
    1: {
      className: "display-xrvj5dj gap-x1c1vhfx gridTemplateColumns-x1mkdm3x opacity-x197sbye transition-x13mcotf transition-x9kvfbb",
      "data-style-src": "wino-gc:src/core/NextResourceDetailsPage.res.js:102; wino-gc:src/core/NextResourceDetailsPage.res.js:111; wino-gc:src/core/NextResourceDetailsPage.res.js:115"
    },
    3: {
      className: "display-xrvj5dj gap-x1c1vhfx gridTemplateColumns-x10rj6eh opacity-x197sbye transition-x13mcotf transition-x9kvfbb",
      "data-style-src": "wino-gc:src/core/NextResourceDetailsPage.res.js:102; wino-gc:src/core/NextResourceDetailsPage.res.js:108; wino-gc:src/core/NextResourceDetailsPage.res.js:111; wino-gc:src/core/NextResourceDetailsPage.res.js:115"
    }
  }[!!desktopScreenSize << 1 | !!stale << 0];
  let newrecord = {
    ...rootProps
  };
  return JsxRuntime.jsx("div", (newrecord.style = match.style, newrecord.className = match.className, newrecord.children = props.children, newrecord));
}
function NextResourceDetailsPage(props) {
  let resourceNameSvg = props.resourceNameSvg;
  let header = props.header;
  let children = props.children;
  let match = Navigation.useGoBack();
  let url = Navigation.useUrl();
  let state = url.state;
  let pathname = url.pathname;
  let navigate = Navigation.useNavigate();
  let match$1 = React.useState(() => false);
  let setScrolled = match$1[1];
  let scrolled = match$1[0];
  let layoutRef = React.useRef(null);
  React.useLayoutEffect(() => {
    let handler = param => {
      let el = layoutRef.current;
      if (!(el == null)) {
        return setScrolled(param => el.scrollTop > 0);
      }
    };
    handler();
    let el = layoutRef.current;
    if (!(el == null)) {
      el.addEventListener("scroll", handler);
      return () => {
        el.removeEventListener("scroll", handler);
      };
    }
  }, []);
  React.useLayoutEffect(() => {
    Stdlib_Nullable.forEach(layoutRef.current, el => {
      el.scrollTop = 0;
    });
  }, [pathname]);
  let initialLoading;
  initialLoading = typeof header !== "object";
  let stale = AsyncResult.isReloading(header);
  let loadingBarStatus = PredictiveLoadingBar.statusFromAsyncResult(header);
  let onRequestGoBack = match[0] ? match[1] : undefined;
  let siblingNavigationElement = React.useMemo(() => {
    let siblingItems = Stdlib_Option.map(ListNavigationState.decode(state), param => param.items);
    let currentIndex = Stdlib_Option.flatMap(siblingItems, items => Stdlib_Array.indexOfOpt(items, pathname));
    if (siblingItems === undefined) {
      return;
    }
    if (currentIndex === undefined) {
      return;
    }
    let goToIndex = targetIndex => {
      let href = siblingItems[targetIndex];
      if (href !== undefined) {
        return navigate(Stdlib_Option.map(state, state => ({
          replace: true,
          state: state
        })), Navigation.urlToRoute({
          pathname: href,
          path: url.path,
          query: url.query,
          state: url.state
        }));
      }
    };
    return JsxRuntime.jsx(CanaryPageHeader.SiblingNavigation.make, {
      previousDisabled: initialLoading || currentIndex <= 0,
      nextDisabled: initialLoading || currentIndex >= (siblingItems.length - 1 | 0),
      onRequestGoPrevious: () => goToIndex(currentIndex - 1 | 0),
      onRequestGoNext: () => goToIndex(currentIndex + 1 | 0)
    });
  }, [state, pathname, url.query, navigate, initialLoading]);
  let loadingBarEstimatedDuration = Stdlib_Option.map(props.loadingOperations, operations => OperationDurations.estimate(undefined, undefined, undefined, operations));
  let pageHeader;
  let exit = 0;
  let resource;
  if (typeof header !== "object") {
    exit = 2;
  } else if (header.TAG === "Reloading") {
    let resource$1 = header._0;
    if (resource$1.TAG === "Ok") {
      resource = resource$1._0;
      exit = 1;
    } else {
      exit = 2;
    }
  } else {
    let resource$2 = header._0;
    if (resource$2.TAG === "Ok") {
      resource = resource$2._0;
      exit = 1;
    } else {
      exit = 2;
    }
  }
  switch (exit) {
    case 1:
      pageHeader = JsxRuntime.jsx(CanaryPageHeader.make, {
        title: resource.resourceName,
        titlePrepender: resourceNameSvg,
        subtitle: resource.subtitle,
        subtitleBadgeElement: resource.subtitleBadgeElement,
        mainActionsElement: resource.mainActionsElement,
        secondaryActionsElement: resource.secondaryActionsElement,
        siblingNavigationElement: siblingNavigationElement,
        actionsInert: stale,
        loadingBarStatus: loadingBarStatus,
        loadingBarEstimatedDuration: loadingBarEstimatedDuration,
        scrolled: scrolled,
        onRequestGoBack: onRequestGoBack
      });
      break;
    case 2:
      pageHeader = JsxRuntime.jsx(CanaryPageHeader.make, {
        title: props.resourceTypeLabel,
        titlePlaceholder: true,
        titlePrepender: resourceNameSvg,
        siblingNavigationElement: siblingNavigationElement,
        loadingBarStatus: loadingBarStatus,
        loadingBarEstimatedDuration: loadingBarEstimatedDuration,
        scrolled: scrolled,
        onRequestGoBack: onRequestGoBack
      });
      break;
  }
  let tmp;
  tmp = typeof header !== "object" ? JsxRuntime.jsx(Placeholder.make, {
    status: "Loading"
  }) : header.TAG === "Reloading" ? header._0.TAG === "Ok" ? JsxRuntime.jsx(NextResourceDetailsPage$ResourceDetailsBody, {
    children: children,
    stale: stale
  }) : JsxRuntime.jsx(Placeholder.make, {
    status: "Error"
  }) : header._0.TAG === "Ok" ? JsxRuntime.jsx(NextResourceDetailsPage$ResourceDetailsBody, {
    children: children,
    stale: stale
  }) : JsxRuntime.jsx(Placeholder.make, {
    status: "Error"
  });
  return JsxRuntime.jsxs(make, {
    children: [pageHeader, JsxRuntime.jsx(Box.make, {
      children: tmp,
      spaceX: "large",
      spaceY: "large"
    })],
    rootRef: layoutRef
  });
}
let Column = {
  make: NextResourceDetailsPage$Column
};
let make$1 = NextResourceDetailsPage;
export { Column, make$1 as make };
/* styles Not a pure module */